import React, { useState, useEffect } from 'react';
import CorporateClients from '../components/CorporateClients';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Sidebar from '../components/Sidebar';

const CorUserPage = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  // Handle window resizing for responsiveness
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setIsSidebarOpen(false); // Collapse sidebar on small screens
      } else {
        setIsSidebarOpen(true); // Expand sidebar on larger screens
      }
    };

    // Add event listener for resize
    window.addEventListener('resize', handleResize);

    // Check initial window size
    handleResize();

    // Clean up the event listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div>
      <div>
        {/* Pass the isSidebarOpen state to Sidebar */}
        <Sidebar isOpen={isSidebarOpen} toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
        <div
          style={{
            marginLeft: isSidebarOpen ? '250px' : '0', // Adjust margin based on sidebar state
            flex: 1,
            transition: 'margin-left 0.3s ease', // Smooth transition when sidebar toggles
            paddingTop: '40px', // Ensure content isn't hidden behind fixed navbar
          }}
        >
          <Navbar />
          <CorporateClients />
          {/* <Footer /> */}

        </div>
      </div>
    </div>
  );
};

export default CorUserPage;